import { render, staticRenderFns } from "./penaltyRules.vue?vue&type=template&id=417812e2&scoped=true&"
import script from "./penaltyRules.vue?vue&type=script&lang=ts&"
export * from "./penaltyRules.vue?vue&type=script&lang=ts&"
import style1 from "./penaltyRules.vue?vue&type=style&index=1&id=417812e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417812e2",
  null
  
)

export default component.exports